import get from 'lodash.get';

import { emptyArray } from '../../../default-props/empty';

export const selectShipmentFromCustomerDetails = (state) => get(state, 'shipmentFromCustomerDetails');
export const selectShipmentDetails = (state) => get(state, 'shipmentDetails');
export const selectFulfillmentPlanIdForShipmentDetailModalId = (state, props) =>
  get(state, `${props.shipmentDetailModalId}.fulfillmentPlanId`);
export const selectShipmentDetailsByShipmentDetailModalId = (state, props) => get(state, `${props.shipmentDetailModalId}`);
export const selectShipmentDetailsModalIds = (state) => (state ? Object.keys(state) : emptyArray);
